import { Fragment } from "react";
import { ExamLabel } from "../../components";
import { Link } from "react-router-dom";
import IMAGE_SUPERVISOR from "../../assets/supervisor.png";
import * as SHARED from "../../utils/shared";

function MenuParticipante() {
  return (
    <Fragment>
      <div className="max-w-xs mx-auto mt-10">
        <ExamLabel
          firstTitle={SHARED.NOMBRE_SISTEMA}
          mainTitle={SHARED.PROCESO}
          style={{ background: "#D41D3D" }}
        />
      </div>

      <p className="text-center mx-auto mb-4 font-semibold">Ingresar al sistema como:</p>

      <div className="w-60 mx-auto my-10">
        <Link
          to="/login"
          className="flex flex-col justify-items-center items-center hover:bg-gray-100 p-5 gap-4 w-full text-center border border-gray-300"
        >
          <img className="rounded" alt="Supervisor" src={IMAGE_SUPERVISOR} />
          <p className="text-gray-700 font-semibold text-base">Registrador</p>
        </Link>
      </div>
    </Fragment>
  );
}

export default MenuParticipante;
